// Libraries
import styled from 'styled-components'

// Components
import { Button, FormButton } from 'heeds-ds'

export const ButtonContainer = styled.div`
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  padding: 40px 0;
  width: 100%;
`

export const CancelButton = styled(Button).attrs(() => ({
  cancel: true,
  margin: '0',
  size: 'small',
  variation: 'outlined',
}))``

export const Container = styled.div`
  display: grid;
  gap: 2.4rem;
  padding: 2.4rem;
  width: 100%;
`

export const Content = styled.div`
  display: grid;
  gap: 2.4rem;
  grid-template-columns: 40% calc(60% - 2.4rem);
  height: 70rem;
  position: relative;
`

export const GoBackButton = styled(Button).attrs(() => ({
  margin: '0',
  size: 'small',
  variation: 'outlined',
}))``

export const NextButton = styled(FormButton).attrs(() => ({
  margin: '0',
  size: 'small',
}))``
